import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router";
import Config from "../config.json";

function Header(props) {
  const [queryParams, setQueryParams] = useState("");
  const navigate = useNavigate();

  const folders = Config.storage.folders
      .filter((f) => f.hidden !== true)
      .sort((a, b) => a.name.localeCompare(b.name));

  const title = process.env.REACT_APP_ENVIRONMENT !== "Production" 
    ? `Document Center - ${process.env.REACT_APP_ENVIRONMENT}`
    : `Document Center`;

  const handleSubmit = (event) => {
    document.getElementById("azure-search-form-input").value = "";

    if (queryParams !== "") {
      // Prevent default native behavior of submit
      event.preventDefault();
      // Push the new location to React Router DOM
      navigate("/Search?text=" + queryParams);
    }
      
  };

  return (
    <header>
      <a
        href="#main-content"
        to="main-content"
        className="visually-hidden focusable"
        tabIndex="1"
        onClick={(e) => e.target.blur()} >
        Skip to main content
      </a>
      <nav
        className="navbar navbar-dark navbar-custom justify-content-between navbar-expand-lg"
        role="navigation"
        aria-label="Header navigation"
      >
        <div className="container">
          <a className="navbar-brand" href="/">City of Bellevue | Document Center</a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
            <ul className="navbar-nav">
             <li className="nav-item">
                <Link to="/" className="nav-link">
                  Home
                </Link>
             </li>
             <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Collections
              </a>
                <div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                  {folders.map((folder) => (
                    <Link key={folder.name} className="dropdown-item" to={`/${folder.name}`}>
                      {folder.title}
                    </Link>
                  ))}
                </div>
              </li>
              <li className="nav-item">
                <Link to="https://bellevuewa.gov" className="nav-link">
                  Bellevue, WA
                </Link>
             </li>
          </ul>
          <div className="navbar-right pl-4">
            <div className="form-group mt-1 mb-1 mr-3" id="azure-search-form">
              <label htmlFor="azure-search-form-input" className="sr-only">
                Global Search{" "}
              </label>
              <div className="input-group">
              <label htmlFor="azure-search-form-input" className="sr-only">Search Across Collections</label>
                <input
                  id="azure-search-form-input"
                  name="dcSearch"
                  onChange={(event) =>
                    setQueryParams(encodeURI(event.target.value))
                  }
                  onKeyDown={(event) => {
                    //13 = "Enter" key
                    if (event.code === 13) {
                      event.target.blur();
                      handleSubmit(event);
                    }
                  }}
                  type="search"
                  className="form-control"
                  autoComplete="off"
                  aria-autocomplete="list"
                  aria-haspopup="true"
                  aria-label="Input box for search text"
                  placeholder="Search Across Collections"
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-teritary btn-outline-light"
                    type="button"
                    onClick={handleSubmit}
                  >
                    Go!
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        </div>
      </nav>
      
    </header>
  );
}

export default Header;
